import SearchPhone from './SearchPhone';

export default SearchPhone;
